export const KEY = 'businessFields';

export const BUSINESS_FIELDS = 'businessFields';
export const BUSINESS_FIELDS_STATUS = 'businessFieldsStatus';
export const EDITED_BUSINESS_FIELD = 'editedBusinessField';
export const BUSINESS_FIELD_CREATE_STATUS = 'businessFieldCreateStatus';
export const BUSINESS_FIELD_EDIT_STATUS = 'businessFieldEditStatus';
export const BUSINESS_FIELD_DELETE_STATUS = 'businessFieldDeleteStatus';
